import { render, staticRenderFns } from "./BasicDataPdf.vue?vue&type=template&id=1fa1f1ff&scoped=true&"
import script from "./BasicDataPdf.vue?vue&type=script&lang=js&"
export * from "./BasicDataPdf.vue?vue&type=script&lang=js&"
import style0 from "./BasicDataPdf.vue?vue&type=style&index=0&id=1fa1f1ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa1f1ff",
  null
  
)

export default component.exports